class ProductWeightScale extends HTMLElement {
  constructor() {
    super()

    this.steps = 5
    this.weightRangeElem = null
    this.ticksContainer = null

    this.boundWeightRangeInputHandler = this.weightRangeInputHandler.bind(this)
  }

  connectedCallback() {
    this.weightRangeElem = this.querySelector('.product__weight-range')
    if (this.weightRangeElem) {
      this.weightRangeElem.addEventListener('input', this.boundWeightRangeInputHandler)
    }

    this.ticksContainer = document.querySelector('.ticks')

    this.displayTicks()
    this.setWeightRangeValue(this.dataset.weightScale)
  }

  disconnectedCallaback() {
    if (this.weightRangeElem) {
      this.weightRangeElem.removeEventListener('input', this.boundWeightRangeInputHandler)
    }
  }

  displayTicks() {
    if (!this.ticksContainer) return

    for (let i = 0; i < this.steps; i++) {
      const dot = document.createElement('span')

      if (i + 1 > this.dataset.weightScale) {
        dot.classList.add('gray')
      }

      this.ticksContainer.appendChild(dot)
    }
  }

  setWeightRangeValue(value) {
    if (!this.weightRangeElem) return

    const numValue = parseInt(value)
    if (Number.isNaN(numValue) || numValue < 0 || numValue > this.steps) return

    this.weightRangeElem.style.setProperty('--val', numValue)
  }

  weightRangeInputHandler(e) {
    this.setWeightRangeValue(e.target.value)
  }
}

customElements.define('product-weight-scale', ProductWeightScale)
